<template>
    <toolbar-option>
        <template slot="primary">
            <dropdown
                :value="selected"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { ACCESSIBILITY_ROLES } from '@/data/constants/accessibility-roles';

export default {
    name: 'accessibility-role',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'role',
            selected: '',
            roleOptions: ACCESSIBILITY_ROLES,
        };
    },

    computed: {
        options() {
            const noneOption = { text: 'None', value: '' };

            if (!this.roleOptions) return [noneOption];

            return [
                noneOption,
                ...this.roleOptions.map(item => ({ text: item, value: item })),
            ];
        },
    },

    watch: {
        roleOptions() {
            if (!this.roleOptions) return;

            this.onSelectedElement();
        },

        selected() {
            this.onOptionChange(this.selected);
        },
    },

    methods: {
        async onInput(selected) {
            this.selected = selected;

            this.selectedElements.forEach((element) => {
                element.accessibilityRoleNew = selected;
            });

            this.onOptionChange(selected);
            this.setChangedData(true);
        },

        onSelectedElement() {
            this.selected = this.selectedElements[0].accessibilityRoleNew;
        },
    },
};
</script>
